import { Box, Chip as MUIChip, styled, Typography } from '@mui/material'
import { VinciButton } from '~/components'

export const Wrapper = styled(Box)(({ theme }) => ({
  padding: [0, theme.spacing(4), theme.spacing(4), theme.spacing(4)].join(' '),
  gap: theme.spacing(4),
  width: theme.breakpoints.values.sm,
}))

export const SectionWrapper = styled(Box)(() => ({}))

export const TitleWrapper = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}))

export const Title = styled(Typography)(({ theme }) => ({
  color: theme.alternativePalette.dark.main,
  margin: [theme.spacing(4), 0].join(' '),
}))

Title.defaultProps = {
  variant: 'h5',
}

export const AdditionalInfoButton = styled(VinciButton)(({ theme }) => ({
  color: theme.alternativePalette.dark.main,
}))
AdditionalInfoButton.defaultProps = {
  variant: 'text',
}

export const ChipsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  padding: [theme.spacing(4), 0].join(' '),
}))

export const Chip = styled(MUIChip)(() => ({}))

Chip.defaultProps = {
  size: 'small',
}
